module.exports = __webpack_public_path__ + "img/panyubg.5047eff9.png";